import { api } from "@lumberset/api-client";
import { TicketThread } from "@lumberset/support-ui";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { Crumbs } from "../../../components/crumbs";
import { ticketQuery } from "../../../lib/queries";

export const Route = createFileRoute("/_app/support/$id")({
  loader: ({ context: { queryClient }, params }) =>
    queryClient.ensureQueryData(ticketQuery(params.id)),
  component: TicketScreen,
});

function TicketScreen() {
  const { id } = Route.useParams();
  const { data } = useSuspenseQuery(ticketQuery(id));
  return (
    <>
      <Crumbs trail={[{ label: "Support", to: "/support" }, { label: data.ticket.title }]} />
      <TicketThread client={api} id={id} />
    </>
  );
}
